import React from 'react'
import { useEffect,useState } from 'react'
import DesktopMiniDrawer from '../../components/MiniDrawer/DesktopMiniDrawer/DesktopMiniDrawer'
import MobileMiniDrawer from '../../components/MiniDrawer/MobileMiniDrawer/MobileMiniDrawer'
import DesktopNavbar from '../../components/Navbar/Desktop/DesktopNavbar'
import MobileNavbar from '../../components/Navbar/Mobile/MobileNavbar'
import EditCustomerProfile from '../../components/EditCustomerProfile/EditCustomerProfileDesktopView/EditCustomerProfile'
import EditCustomerProfileMobileView from '../../components/EditCustomerProfile/EditCustomerProfileMobileView/EditCustomerProfileMobileView'
import CustomerProfileTopButtons from '../../components/CustomerProfileTopButtons/CustomerProfileTopButtons'


function CustomerProfile() {
  const [isMiniDrawerVisible, setIsMiniDrawerVisible] = useState(false); 

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 
  
  const toggleMiniDrawer = () => {
    setIsMiniDrawerVisible(!isMiniDrawerVisible);
  };
  return (
    <div>
          <div style={{ backgroundColor: "#F2F4F6" }} className='orderSummary-mobile-hide'>
        <div style={{ padding: "0px", margin: "0px" }} className='container-fluid navbar-mobile-hide'>
          <DesktopNavbar />
        </div>
        <div className='row p-0'>
          <div className='col-2 p-0'>
            <DesktopMiniDrawer />
          </div>
          <div className='col-10 mb-4' style={{marginTop:"90px"}} >
          <CustomerProfileTopButtons/>
            <EditCustomerProfile/>
            </div>
        </div>
      </div>

      {/* mobile view  */}
      <div style={{ backgroundColor: "#F2F4F6"}} className="orderSummary-mobile-show">
        <div style={{ padding: "0px", margin: "0px" ,opacity: isMiniDrawerVisible ? 0.5 : 1, transition: 'opacity 0.3s'}} className='container-fluid'>
          <MobileNavbar onToggle={toggleMiniDrawer} active="profile" />
        </div>
        <div className='row p-0'>
          <div className='col-12 p-0 mobile-view-show' style={{ opacity: isMiniDrawerVisible ? 0.5 : 1, transition: 'opacity 0.3s',marginTop:"81px"}}>
            <CustomerProfileTopButtons/>
            <EditCustomerProfileMobileView/>
          </div>
          {isMiniDrawerVisible && (
            <div className='col-12'>
              <MobileMiniDrawer onClose={toggleMiniDrawer} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CustomerProfile